import { render, staticRenderFns } from "./public-notifications-edit.vue?vue&type=template&id=22267a2c"
import script from "./public-notifications-edit.vue?vue&type=script&lang=js"
export * from "./public-notifications-edit.vue?vue&type=script&lang=js"
import style0 from "./public-notifications-edit.vue?vue&type=style&index=0&id=22267a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports